/**
 * Standalone leaf module (no imports) so both useCollabSession.ts and
 * settings/pages/collaboration.ts can share this list without either pulling
 * the other's dependency graph in — useCollabSession.ts transitively reaches
 * editor/schema.ts, which reads a setting at module load time (baseExtensions),
 * and collaboration.ts is itself loaded by settings/registry.ts's
 * require.context, so importing useCollabSession.ts directly from a settings
 * page would risk a circular require back into registry.ts mid-load.
 */
export const CURSOR_COLORS = [
  "#ef4444", "#f59e0b", "#10b981", "#3b82f6", "#8b5cf6", "#ec4899", "#14b8a6", "#f97316",
];
